import axios from 'axios';
import authConfig from '@/../auth_config.json';

let auth = axios.create({
    baseURL: `${authConfig.oauthDomain}api/v1/`,
})
auth.interceptors.request.use(function (config) {
    let token = localStorage.getItem("access_token");
    if (token) {
        config.headers["Authorization"] = "Bearer " + token;
    }
    return config
});
auth.interceptors.response.use(function (config) {
        if (config && config.status === 401) {
            localStorage.clear();
            return this.$router.push("/pages/login");
        }
        let token = localStorage.getItem("access_token");
        let language = localStorage.getItem("language");
        if (!language) language = "vi-VN";
        config.headers["Accept-Language"] = language;
        if (token) {
            config.headers["Authorization"] = "Bearer " + token;
        }
        return config;
    },
    function (error) {
        if (error && error.response.status === 401) {
            localStorage.clear();
            return location.reload();
        }
        return Promise.reject(error)
    }
    )

export default auth;
